import React from 'react'
import PropTypes from 'prop-types'
import { Button, Icon, Text } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import NearbyCheckbox from '../nearbyCheckbox'
import styles from './styles.scss'
const cx = classnames.bind(styles)

export const BASE_ELM_ID = 'no_results_page'

const NoResultsPage = ({
  filters,
  assets,
  updateFiltersAction,
  onSaveSearch,
  featureFlags,
}) => {
  const hasNewNavigation = featureFlags?.['fe.resi.enable-new-navigation']

  if (!hasNewNavigation) {
    return (
      <div className={cx('no-results-container')}>
        <div className={cx('u-pt-1', 'u-pb-1', 'u-ml-3')}>
          <NearbyCheckbox
            className={cx('checkbox')}
            filters={filters}
            assets={assets}
            elmId={BASE_ELM_ID}
            updateFiltersAction={updateFiltersAction}
          />
        </div>
        <div data-elm-id={BASE_ELM_ID} className={cx('root')}>
          <Icon
            data-elm-id={`${BASE_ELM_ID}_icon`}
            className={cx('main-icon')}
            iconStyle='light'
            size='massive'
            name='home'
          />
          <h2
            className={cx('u-mt-4', 'u-mb-2')}
            data-elm-id={`${BASE_ELM_ID}_header`}
          >
            No Matching Properties
          </h2>
          <p className={cx('no-results-label')}>
            <a
              data-elm-id={`${BASE_ELM_ID}_save_search_link`}
              onClick={onSaveSearch}
            >
              Save this search
            </a>{' '}
            to get email alerts when properties hit the market
          </p>
          <p className={cx('no-results-label')}>
            To get more results, change some filters, or expand the area of your
            search
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className={cx('no-results-container', 'new-design')}>
      <div className={cx('u-pt-1', 'u-pb-1', 'u-ml-3', 'hide-on-mobile')}>
        <NearbyCheckbox
          className={cx('checkbox')}
          filters={filters}
          assets={assets}
          elmId={BASE_ELM_ID}
          updateFiltersAction={updateFiltersAction}
        />
      </div>
      <div data-elm-id={BASE_ELM_ID} className={cx('root', 'new-root')}>
        <div className={cx('icon-circle')}>
          <Icon
            name='location-dot'
            iconStyle='solid'
            size='large'
            className={cx('new-main-icon')}
          />
        </div>
        <Text.Header
          as='h2'
          size='large'
          weight='black'
          color='grayDark'
          className={cx('u-mt-3', 'u-mb-2')}
          data-elm-id={`${BASE_ELM_ID}_header`}
        >
          No Matching Properties
        </Text.Header>
        <Text
          as='p'
          size='small'
          color='gray'
          className={cx('no-results-label')}
        >
          To get more results, change some filters, or expand the area of your
          search
        </Text>
        <Button
          role='secondary'
          elmId={`${BASE_ELM_ID}_save_search`}
          className={cx('save-search-button')}
          onClick={onSaveSearch}
        >
          <Icon name='bookmark' iconStyle='regular' /> Save search for updates
        </Button>
      </div>
    </div>
  )
}

NoResultsPage.propTypes = {
  filters: PropTypes.object.isRequired,
  assets: PropTypes.object.isRequired,
  updateFiltersAction: PropTypes.func.isRequired,
  onSaveSearch: PropTypes.func.isRequired,
  featureFlags: PropTypes.object,
}

export default NoResultsPage
